import { compose, branch, renderNothing, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import WithShopCurrency from '../../hoc/WithShopCurrency';
import { getIsLadyClipperShop, getIsKrwnZazzPlaceSteFoyShop, getNoExtrasForReserveNoPay } from '../../shops/selectors';
import WithBookNoPayQuery from '../../hoc/WithBookNoPayQuery';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import Pay from '../components/Pay';
import WithShop from '../../hoc/WithShop';
import WithThirdPartyPromo from '../../hoc/WithThirdPartyPromo';
import withCost from './withCost';
import withKioskIsReserveOnly from './withKioskIsReserveOnly';

export default compose(
  withCost,
  WithShop,
  WithThirdPartyPromo,
  withKioskIsReserveOnly,
  WithApplePayQuery,
  withRouter,
  branch(
    prop => prop.withApplePay,
    renderNothing,
  ),
  connect((state, ownProps) => ({
    isLadyClipperShop: getIsLadyClipperShop(state, ownProps.params.shopRoute),
    noExtrasForBookNoPay: getNoExtrasForReserveNoPay(state, ownProps.params.shopRoute),
    isKrwnZazzPlaceSteFoyShop: getIsKrwnZazzPlaceSteFoyShop(state, ownProps.params.shopRoute),
  })),
  WithShopCurrency,
  WithBookNoPayQuery,
  withProps((props) => {
    if (!props.shop) {
      return {
        isReserveAndPayAvailable: false,
        isReserveWithCardAvailable: false,
        isReserveNoPayAvailable: false,
      };
    }

    if (!!props.isCoveredByDiscount && !props.noExtrasForBookNoPay) {
      return {
        isProcessAvailable: true,
      };
    }

    return {
      isReserveAndPayAvailable: (
        (!!props.totalAmount || props.noExtrasForBookNoPay) && !props.bookNoPayQuery && !props.isReserveNoPayOnly
      ),
      isReserveWithCardAvailable: (
        !!props.totalAmount && props.bookAndReserve && !props.isReserveNoPayOnly
      ),
      isReserveNoPayAvailable: (
        (!props.totalAmount
          || (props.bookNoPay && !props.bookAndReserve)
          || props.isReserveNoPayOnly
        ) && !props.discount
      ),
    };
  }),
)(Pay);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/Pay.js